"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      width: '33.33%',
      borderRight: '1px solid',
      borderRightColor: theme.palette.divider,
      '&:nth-of-type(3n)': {
        borderRight: 'none'
      },
      '&:not(:nth-of-type(3n+1))': (0, _defineProperty2.default)({
        paddingRight: theme.spacing(4),
        paddingLeft: theme.spacing(4)
      }, theme.breakpoints.down('md'), {
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2)
      })
    }, theme.breakpoints.down('sm'), {
      width: 'auto'
    }),
    btn: {
      color: theme.palette.text.primary,
      textTransform: 'none',
      fontSize: 16,
      textAlign: 'left'
    },
    menuItem: {
      '&:hover': {
        backgroundColor: 'rgba(206, 31, 36, 0.04)'
      }
    },
    menuLabel: (0, _extends2.default)({}, theme.typography.body1, {
      padding: theme.spacing(1),
      paddingTop: 0,
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.divider,
      outline: 'none'
    })
  };
}, {
  name: 'SelectMultipleMenuField'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_ExpandMore.default, {
  color: "primary"
});

function SelectMultipleMenuField(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      label = _ref.label,
      onChange = _ref.onChange,
      options = _ref.options,
      value = _ref.value,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "label", "onChange", "options", "value"]);
  var classes = useStyles({
    classes: pClasses
  });

  var _React$useState = _react.default.useState(null),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var open = Boolean(anchorEl);
  var t = (0, _useTranslate.default)();

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var handleChange = _react.default.useCallback(function (v) {
    return function () {
      var vv = value || [];
      var i = vv.indexOf(v);
      var nextV = i >= 0 ? [].concat((0, _toConsumableArray2.default)(vv.slice(0, i)), (0, _toConsumableArray2.default)(vv.slice(i + 1))) : [].concat((0, _toConsumableArray2.default)(vv), [v]);
      onChange(nextV);
    };
  }, [onChange, value]);

  var nLabel = label ? t(label, {
    acceptString: true
  }) : '';
  var nextLabel = nLabel.length > 25 ? "".concat(nLabel.slice(0, 23), "...") : nLabel;

  _react.default.useEffect(function () {
    return setAnchorEl(null);
  }, []);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-controls": "fade-menu",
    "aria-haspopup": "true",
    onClick: handleClick,
    color: "primary",
    className: classes.btn
  }, nextLabel, " ", _ref2), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    id: "fade-menu",
    anchorEl: anchorEl,
    keepMounted: true,
    open: open,
    onClose: handleClose
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.menuLabel
  }, nLabel), options.map(function (i, index) {
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      key: index.toString(),
      onClick: handleChange(i.value),
      className: classes.menuItem
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      color: "primary",
      checked: Boolean(value && value.indexOf(i.value) >= 0)
    }), /*#__PURE__*/_react.default.createElement(_Typography.default, null, i.label ? t(i.label, {
      acceptString: true
    }) : 'banan', " (", i.count, ")"));
  })));
}

process.env.NODE_ENV !== "production" ? SelectMultipleMenuField.propTypes = {
  classes: _propTypes.default.shape({
    btn: _propTypes.default.string,
    menuItem: _propTypes.default.string,
    menuLabel: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  label: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.arrayOf(_propTypes.default.shape({}))])
} : void 0;
SelectMultipleMenuField.defaultProps = {
  classes: undefined,
  className: undefined,
  label: undefined,
  value: undefined
};
var _default = SelectMultipleMenuField;
exports.default = _default;